/** Pure export helpers (no network): which formats a page offers, and the CSV and table bodies of what it shows. */

export const STANDARD_FORMATS = [
  { format: 'csv', label: 'CSV', description: 'Comma-separated values (.csv)' },
  { format: 'xlsx', label: 'Excel workbook', description: 'Formatted workbook with filters applied (.xlsx)' },
];

/**
 * The formats an export can really produce: a server endpoint renders every format (extraFormats, such as the PDF
 * summary, first, then CSV and Excel); a table the page shows (columns + rows) renders CSV and Excel; nothing else
 * offers no format, so the menu is not shown (G3 review: never show a format that has nothing behind it).
 */
export function exportFormats({ endpoint, columns, rows, extraFormats = [] }) {
  if (endpoint) return [...extraFormats, ...STANDARD_FORMATS];
  if (columns && rows) return STANDARD_FORMATS;
  return [];
}

const csvCell = (value) => {
  if (value == null) return '';
  let s = String(value);
  if (typeof value === 'string' && /^[=+\-@\t\r]/.test(s)) s = `'${s}`;
  return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

const cellValue = (c, row) => {
  if (c.exportValue) return c.exportValue(row);
  if (typeof c.value === 'function') return c.value(row);
  return row[c.key];
};

const plain = (v) => {
  if (v == null) return null;
  if (typeof v === 'number') return Number.isFinite(v) ? v : null;
  if (typeof v === 'boolean') return v;
  return String(v);
};

const headerOf = (c) => (typeof c.header === 'string' ? c.header : c.exportHeader || c.key);

export function rowsToCsv(columns, rows) {
  const exportable = columns.filter((c) => c.export !== false);
  const header = exportable.map((c) => csvCell(headerOf(c))).join(',');
  const lines = rows.map((row) => exportable.map((c) => csvCell(cellValue(c, row))).join(','));
  return [header, ...lines].join('\r\n');
}

/** The table the page shows as the JSON body of POST export/table: text, numbers, true/false or null per cell. */
export function rowsToTable(title, columns, rows) {
  const exportable = columns.filter((c) => c.export !== false);
  return {
    title,
    columns: exportable.map((c) => ({ key: c.key, header: String(headerOf(c)) })),
    rows: rows.map((row) => exportable.map((c) => plain(cellValue(c, row)))),
  };
}
